import {lazy} from 'react';

export const InfoHeaderLazy = lazy(() => import(/* webpackChunkName: "infoHeader" */ '.'));
